import { render, staticRenderFns } from "./jointActivity.vue?vue&type=template&id=7a4ef0f2&scoped=true&"
import script from "./jointActivity.vue?vue&type=script&lang=js&"
export * from "./jointActivity.vue?vue&type=script&lang=js&"
import style0 from "./jointActivity.vue?vue&type=style&index=0&id=7a4ef0f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4ef0f2",
  null
  
)

export default component.exports